export default __webpack_public_path__ + "static/courses-frames-bd78ae15a471bd5d7a48001fd257473a.gif";